import React, { useState } from 'react';
import moment from 'moment';
import { gql } from '@apollo/client';
import { withRouter } from 'react-router';

import { historyShape, userShape } from 'constants/propTypes';
import { withStations } from 'components/queries/GetStationsQuery';
import { useManagedQuery, useManagedMutation } from 'utils/managedHooks';
import Spinner from 'admin-components/components/Spinner';

import formatExtras from './formatExtras';
import ExtrasOnlyBooking from './ExtrasOnlyBooking';
import { Column } from '../../components/shared/Layout';

const today = moment().format('YYYY-MM-DD');

const GET_AVAILABLE_EXTRAS = gql`
  query getAvailableExtras($departureDate: String!, $currency: Currency!) {
    getAvailableExtras(departureDate: $departureDate, currency: $currency) {
      tariffCode
      name
      type
      price
    }
  }
`;

const CREATE_EXTRAS_ONLY_BOOKING = gql`
  mutation createExtrasOnlyBooking(
    $segments: [InputSegment]
    $passengers: [InputPassenger]
    $customer: CustomerInput
    $currency: String
    $associatedBookingReference: String
  ) {
    createExtrasOnlyBooking(
      segments: $segments
      passengers: $passengers
      customer: $customer
      currency: $currency
      associatedBookingReference: $associatedBookingReference
    ) {
      reference
      totalPriceToBePaid
      currency
    }
  }
`;

const Index = ({ user, history: { push }, ...props }) => {
  const {
    paymentCurrencies: [defaultCurrency]
  } = user;

  const [currency, setCurrency] = useState(defaultCurrency);

  const { loading: getAvailableExtrasLoading, data } = useManagedQuery(GET_AVAILABLE_EXTRAS, {
    variables: {
      departureDate: today,
      currency
    }
  });

  if (data && !data.getAvailableExtras.length) {
    throw new Error(`No available extras found.`);
  }

  const [createExtrasOnlyBooking, { loading: createBookingLoading }] = useManagedMutation(CREATE_EXTRAS_ONLY_BOOKING);

  const onSubmit = async (values) => {
    const { data: newBooking } = await createExtrasOnlyBooking({
      variables: formatExtras(values, currency)
    });
    const { reference, totalPriceToBePaid } = newBooking.createExtrasOnlyBooking;

    if (totalPriceToBePaid > 0) {
      push(`/booking/${reference}/payment`);
    } else {
      push(`/manage/bookings/${reference}/journeys`);
    }
  };

  if (getAvailableExtrasLoading || createBookingLoading) {
    return (
      <Column alignItems="center" justifyContent="center">
        <Spinner />
      </Column>
    );
  }

  return (
    <ExtrasOnlyBooking
      {...props}
      availableExtras={data.getAvailableExtras}
      onSubmit={onSubmit}
      currency={currency}
      updateCurrency={setCurrency}
    />
  );
};

Index.propTypes = {
  user: userShape,
  history: historyShape
};

export default withRouter(withStations(Index));
